import { validateProfileHandle, validatePublicId } from "./appLinks";

export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "https://api.dev.mondoway.com"
).replace(/\/$/, "");

export class ProfileResolutionError extends Error {
  constructor(message, status = 0) {
    super(message);
    this.name = "ProfileResolutionError";
    this.status = status;
  }
}

export async function resolveProfileHandle(profileId, options = {}) {
  const validProfileId = validatePublicId(profileId);

  if (!validProfileId) {
    throw new ProfileResolutionError("Invalid profile ID");
  }

  const response = await fetch(
    `${API_BASE_URL}/v1/user-app/social/profiles/${encodeURIComponent(
      validProfileId
    )}`,
    {
      headers: { Accept: "application/json" },
      signal: options.signal
    }
  );

  if (!response.ok) {
    throw new ProfileResolutionError(
      "Unable to resolve this profile",
      response.status
    );
  }

  const payload = await response.json();
  const handle =
    payload?.data?.share?.handle || payload?.data?.profile?.name || "";
  const validHandle = validateProfileHandle(handle);

  if (!validHandle) {
    throw new ProfileResolutionError("The profile has no valid handle");
  }

  return validHandle;
}
